"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mempool_space_default_1 = __importDefault(require("./mempool-space-default"));
class MempoolSpace extends mempool_space_default_1.default {
    constructor(testnet = false) {
        const baseUrl = testnet ? "https://mempool.space/testnet4/api" : "https://mempool.space/api";
        super(baseUrl);
    }
}
exports.default = MempoolSpace;
//# sourceMappingURL=mempool-space.js.map